import { ITab } from '@/shared/Tabs/tabs.types.ts'
import { TEquipmentTabType } from '@/pages/Equipment/equipment.types.ts'

const cardTabs: ITab<TEquipmentTabType>[] = [
  { title: 'Устройства', id: 'equipment' },
  { title: 'Запросы подключения', id: 'connection-requests' },
]

const equipmentPageConstants = { cardTabs }
export default equipmentPageConstants
